import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm, FormControl} from '@angular/forms';

import {AppserviceService} from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-stockinsert',
  templateUrl: './stockinsert.component.html',
  styleUrls: ['./stockinsert.component.sass']
})
export class StockinsertComponent implements OnInit {
  stockform:any;
  partsObj:any = [];
  partsError:string;
  stockInsertObj = {};
  partselected = '';
  stockModel = {
    'consignmentno':'',
    'partsearch':''
  };
  consignmentfound:boolean = false;
  consignmentMsg:string = 'An outstanding receipt with an identical consignment number value has been automatically receipted into Quarantine.';
  consignmentObj = [];
  consignObj = {};
  stockUpdateBool:boolean = false;
  stockUpdateMsg = '';
  stockUpclass = "";

  constructor(private _formBuilder: FormBuilder, private AppService:AppserviceService, private spinner:NgxSpinnerService) {}

  searchConNo(consign){
    this.consignObj = {
      'CCH_PART':'',
      'CCH_CONSIGNMENT_NUMBER':consign.target.value,
      'CCH_TOSTORE':'QUARANTINE'
    };
    this.spinner.show();
    this.AppService.checkValidConsigment(this.consignObj).subscribe(
      (consignData) => {
        this.spinner.hide();
        //console.log(consignData);
        if(consignData['data'].length != 0){
          this.consignmentObj = consignData['data'][0];
          this.consignmentfound = true;
        }else{
          this.consignmentfound = false;
        }
      },
      (err) => { 
        this.spinner.hide();
      }
    );
  }

  searchStore(partSearch){
    if(partSearch.target.value.length >= 3){
      this.spinner.show();
      this.AppService.searchPart(partSearch.target.value).subscribe(
        (partsData) => {
          this.spinner.hide();
          //console.log(partsData);
          this.partsObj = partsData['data'];
        },
        (err) => {
          console.log(err);
          this.spinner.hide();
          this.partsError = 'No Parts found!';
        }
      )
    }else{
      this.partsObj = [];
    }
  }

  selectPart(part){
    //console.log(part);
    this.stockInsertObj['from_store'] = 'QUARANTINE';
    this.stockInsertObj['to_store'] = 'GOODSIN';
    //this.stockInsertObj['CCH_PART'] = part;
    this.stockInsertObj['part_code'] = part['bis_part'];
    this.stockInsertObj['qty'] = 1;
    this.stockInsertObj['consignment_code'] = this.consignObj['CCH_CONSIGNMENT_NUMBER'];
    this.stockInsertObj['add_qty'] = 1;
    this.stockInsertObj['engineer'] = localStorage.getItem('username');
    this.partselected = part['bis_part'];
    //console.log(this.stockInsertObj);
  }

  stockUpdate(){
    //console.log(this.stockInsertObj);
    this.spinner.show();
    this.AppService.stockUpdate(this.stockInsertObj).subscribe(
      (sudata) => {
        this.spinner.hide();
        console.log(sudata);
        this.stockUpdateBool = sudata['success'];
        this.stockUpdateMsg = sudata['message'];
        this.stockUpclass = "bg-success";
      },
      (err) => {
        // tslint:disable-next-line:no-unused-expression
        this.spinner.hide;
        console.log(err);
        this.stockUpdateBool = true;
        this.stockUpdateMsg = "Stock not updated!";
        this.stockUpclass = "bg-danger";
      }
    );
  }

  ngOnInit() {
    this.stockform = new FormGroup({
      'consignmentno':new FormControl(this.stockModel.consignmentno,[
        Validators.required
      ]),
      'partsearch':new FormControl(this.stockModel.partsearch,[
        Validators.required
      ])
    });
  }

}
